export const data = {
  productButtons: [
    { label: 'It was damaged or faulty', id: 'faulty', isFocused: true },
    { label: 'Not of satisfactory quality or as described', id: 'badQuality' },
    { label: 'There is a safety issue', id: 'safety' },
    { label: 'I was sent the wrong product', id: 'wrongProduct' },
    { label: "I don't want it any more", id: 'changedMind' },
  ],
  digitalButtons: [
    { label: 'It’s not as described', id: 'notAsDescribed', isFocused: true },
    { label: 'It’s not of satisfactory quality', id: 'badQuality' },
    { label: 'It’s not fit for purpose', id: 'notFitForPurpose' },
    { label: 'Performance reduced over time', id: 'performanceReduced' },
    { label: 'It damaged a device I downloaded/installed it on', id: 'damagedDevice' },
    { label: "I don't want it any more", id: 'changedMind' },
  ],
  imgObj: {
    alt: '',
    src: 'https://media.product.which.co.uk/prod/images/original/7fbb28633e11-tooliconwashingmachine.jpg',
  },
  title: 'What is wrong with the item you bought?',
}
